import { useProductsFilters } from "lib/products"
import { useTranslation } from "lib/i18n/translation"

export default ({}) => {

	const { c } = useTranslation("common")
	const { loading } = useProductsFilters()

	if (loading) {
		return (
			<div style={{width: "100%", display: "flex", alignItems: "center", justifyContent: "center", height: "30px", marginBottom: "20px"}}>
				<span className="loader" />
				<span style={{marginLeft: "20px"}}>{c("loading-films")}</span>
			</div>
		)
	} else {
		return null
	}
}
